import React from 'react'

const EditorPage = () => {
  return (
    <div>
      EditorPage
    </div>
  )
}

export default EditorPage
